import { computed, observable, action } from 'mobx';

import { AppManager, Variables } from 'core';
import { FormStore } from 'libs/forms/app';

import { ProcessesApp, RFQApp } from 'apps/rfq/app';

const dfmProcessConfig = {
  dfmProcessForm: {
    fields: ['process'],
    styles: {
      labelBold: true,
    },
  },
  fields: {
    process: {
      type: 'process',
    },
  },
};

export class DFMIssuesAppManager extends AppManager {
  rfqApp: RFQApp = null;

  @observable target: any = {
    process: null,
    manager: null,
  };

  @observable dfmProcessFormStore: FormStore = null;

  declare dfmProcesses: ProcessesApp;

  constructor(parentAppManager: AppManager, props: any, options: any) {
    super(parentAppManager, props, options);

    this.rfqApp = props?.rfqApp;
    const jobSpec = this.rfqApp?.jobSpec;

    // when comming from standalone DFM tool, there is neiher RFQ nor job spec...
    this.variables = jobSpec
      ? // comming from RFQ, get all available processes for given material
        new Variables({
          processFilter: () => {
            return {
              materialId: jobSpec.build.material?.id || null,
              name: jobSpec.build.material?.materialName || null,
            };
          },
        })
      : // coming from standalone DFM analysis tool, get all available processes
        // FIXME: we should show only the processes we're able to analyze
        //        (the ones for which we have a set of well defined features with cutoffs).
        new Variables();

    this.AppRef('dfmProcesses', ProcessesApp);

    // This is a hack. The FormStore looks at target.manager to set as parent of the
    // (Tree)OptionsManager which will make it be able to see the variables to query as needed
    // Typically target would be an App with a manager set to this manager.
    this.target.manager = this;
    this.target.process = jobSpec?.build.process;

    this.dfmProcessFormStore = new FormStore(
      this.target,
      dfmProcessConfig,
      'dfmProcessForm',
      false, // autoFocusFirstField
    );

    this.dfmProcessFormStore.fieldConf.find(
      conf => conf.fieldName === 'process',
    ).label = 'Fabrication Process';
  }

  @computed get dfmProcess() {
    return this.target.process;
  }

  @action SetProcess(process: ProcessesApp) {
    if (!process) {
      this.target.process = this.rfqApp?.jobSpec.build.process;
    } else {
      this.target.process = process;
    }
  }
}
